// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"185":"b884a44b","189":"b884a44b","573":"ec03c9b0","626":"d5572710"}[chunkId] + ".css";
};